import React from 'react';
import MypagePaymentContainer from 'containers/MypagePaymentContainer/MypagePaymentContainer';

export default function MypagePaymentPage() {
    return (
        <MypagePaymentContainer />
    )
}
